import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Header from './Components/Header';
import Footer from './Components/Footer';
import routes from './Constants/routes';
import Loading from './Components/Loading';
import DatePicker from './Components/DatePicker';
import { PopupFrame, PopupMessage } from './Components/Popup';

function App() {
  return (
    <div className="knsl-app">
      <Loading/>
      <DatePicker />
      <Router>
        <Header/>
        <Switch>
          {routes.map(route => <Route exact key={route.name} path={route.path} component={route.layout}></Route>)}
          <Redirect to="/" />
        </Switch>
        <Footer/>
      </Router>
      <PopupFrame/>
      <PopupMessage/>
    </div>
  );
}

export default App;

